<template>
  <div class="coupon-list-popup">
    <div class="coupon-list-popup-shade"></div>
    <div class="coupon-list-popup-content">
      <p class="coupon-list-popup-title">{{ letter.quanGift }}</p>
      <div class="coupon-list-popup-content-scroll">
        <p class="coupon-list-tip">{{ letter.quanGiftTips }}</p>
        <template v-if="couponList.length">
          <coupon-item
            v-for="item in couponList"
            :key="item.COUPON_ID"
            :info="item"
            :active="false"
            :languages="letter"
            @closePopup="hidePopup"
          ></coupon-item>
        </template>
      </div>
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
        >x</a
      >
    </div>
  </div>
</template>

<script>
import CouponItem from './CouponItem.vue';

export default {
  name: 'CouponActivityPopup',
  props: ['couponList', 'letter'],
  methods: {
    hidePopup() {
      this.$emit('closeCouponPopup');
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/base.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 90%;
    background-color: #f3f3f3;
    padding: 49px 30px 50px;
    box-sizing: border-box;
    &-scroll {
      overflow: -moz-scrollbars-none;
      overflow-y: scroll;
      position: relative;
      max-height: 90%;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
      .coupon-list-tip {
        margin-bottom: 20px;
        text-align: left;
        font-size: 20px;
        color: red;
      }
    }
  }
  &-title {
    color: #414141;
    margin-bottom: 39px;
    text-align: center;
    font-size: 36px;
  }
  &-tip {
    font-size: 20px;
    color: #62c6c4;
  }
  &-close {
    position: absolute;
    top: 30px;
    right: 31px;
    width: 37px;
    height: 37px;
    font-size: 52px;
    color: #414141;
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) {
  .coupon-list-popup {
    &-content {
      width: 70%;
      padding: 49px 88px 150px;
    }
  }
}
</style>